import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';


@Injectable()
export class SetorAtuacaoService {

  url: string = environment.BASE_URL;

  private setorAtuacao = new Subject<any>();
  setorAtuacao$ = this.setorAtuacao.asObservable();

  constructor(private http: HttpClient) {}

  getSetorAtuacao(searchParams): Observable<any> {
    const params = this.setParams(searchParams);
    return this.http.get(`${this.url}/setoresAtuacao/listaSetoresAtuacao`, {params: params})
      .map(data => {
        const body = data;
        this.setorAtuacao.next(body);
        return body;
      });
  }

  setParams(searchParams: any){
    let params = new HttpParams();
    if (!searchParams) {
      return params;
    }
    if (searchParams.key && searchParams.value) {
      return params.set(searchParams.key, searchParams.value);
    }
    for (const key of Object.keys(searchParams)) {
      params = params.set(key, searchParams[key]);
    }
    return params;
  }


  obterSetorAtuacao(id: number): Observable<any> {
    return this.http.get(`${this.url}/setoresAtuacao/${id}`)
      .map(data => {
        const body = data;
        return body;
      });
  }

  editaSetorAtuacao(params: any, code): Observable<any> {
    const setorAtuacao = params;
    const codigo = code;
    return this.http.put(`${this.url}/setoresAtuacao/${codigo}`, setorAtuacao)
      .map(data => {
        const body = data;
        return body;
      });
  }

  incluirPersonalidadeJuridica(obj): Observable<any> {
    return this.http.post(`${this.url}/setoresAtuacao/incluir`, obj)
  }

  consultaCodigo(codigo): Observable<any> {
    return this.http.get(`${this.url}/setoresAtuacao/${codigo}`)
  }

}
